import React from 'react'
import { Link } from 'react-router-dom'
import SEO from './SEO'
import CardComponent from './CardComponent'
import './../styles/Services.css'
import './../styles/CardComponent.css'

const Services = () => (
  <>
    <SEO
      path="/services"
      title="Services — Software Testing, App & Web Development"
      description="Explore QA Tech's services: software testing, app development, web development, mobile development, technical resourcing and DevOps support. Engineering teams that ship with confidence."
      keywords="software testing services, app development, web development, mobile development, technical resourcing, DevOps support, QA consultancy, UK software services"
      jsonLd={{
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: 'Services — QA Tech',
        url: 'https://qatechltd.com/services',
        description:
          'Software testing, app development, web development, mobile development, technical resourcing and DevOps support from QA Tech.',
        about: [
          'Software Testing',
          'App Development',
          'Web Development',
          'Mobile Development',
          'Technical Resourcing',
          'DevOps & CI/CD',
        ],
      }}
    />
    <div className="body services-index">
      <header className="services-index__hero">
        <span className="eyebrow">Our services</span>
        <h1>Software quality, engineering &amp; growth — under one roof.</h1>
        <p>
          Explore the full range of services QA Tech offers ambitious businesses
          across the UK and worldwide. Click any service for the deep dive.
        </p>
      </header>

      <div className="cards-container">
        <CardComponent
          title="App Development"
          body="Full-stack application development with comprehensive testing from conception to deployment"
          icon="development-alt"
          to="/services/app-development"
        />
        <CardComponent
          title="Software Testing"
          body="Expert QA services including automated testing, performance testing, and quality assurance"
          icon="testing-alt"
          to="/services/software-testing"
        />
        <CardComponent
          title="Technical Resourcing"
          body="Skilled QA engineers and developers at all levels to scale your development teams"
          icon="resourcing-alt"
          to="/services/technical-resourcing"
        />
        <CardComponent
          title="DevOps & CI/CD"
          body="Streamlined deployment pipelines with automated testing and continuous integration processes"
          icon="devops-alt"
          to="/services/devops-cicd"
        />
        <CardComponent
          title="Web Development"
          body="Modern responsive websites and web applications with comprehensive testing and optimization"
          icon="web-alt"
          to="/services/web-development"
        />
        <CardComponent
          title="Mobile Development"
          body="Native and cross-platform mobile applications with thorough testing for iOS and Android"
          icon="mobile-alt"
          to="/services/mobile-development"
        />
      </div>

      <div className="services-index__footer">
        <p>
          Looking for marketing instead? See our{' '}
          <Link to="/marketing">marketing services</Link> &mdash; SEO, Google
          setup, ads and full rebrands.
        </p>
      </div>
    </div>
  </>
)

export default Services
